<template>
  <div id="overviewMain">
    <h2
      v-if="['mobile', 'tablet'].includes($mq)"
      class="mHead"
    >
      {{ $t('aside.actionPlan') }}
    </h2>
    <OverviewTop
      class="top"
      :submitted="actionPlans.submitted"
      :status="actionPlans.status"
      :stats="stats"
      :loading="loading"
      :past-engagement="!!engagement"
    />

    <OverviewDetails
      class="details"
      :stats="stats"
      :loading="loading"
      :engagement="engagement"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import OverviewTop from './OverviewTop.vue';
import OverviewDetails from './OverviewDetails.vue';

export default {
  components: {
    OverviewTop,
    OverviewDetails,
  },

  props: {
    actionPlans: {
      type: Object,
      default: null,
    },

    actionPlansOverview: {
      type: Array,
      default: null,
    },

    engagement: {
      type: Object,
      default: null,
    },

    leaderUuid: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      localOverview: null,
      loading: false,
    };
  },

  computed: {
    ...mapState({
      role_type: (state) => state.user.user.role_type,
    }),

    stats() {
      if (this.actionPlansOverview) {
        return this.actionPlansOverview;
      }
      return this.localOverview;
    },
  },

  created() {
    if (!this.actionPlansOverview) {
      this.getOverviewStat();
    }
  },

  methods: {
    async getOverviewStat() {
      try {
        let response;
        this.loading = true;
        if (this.role_type === 'coach' && this.leaderUuid) {
          response = await api.getCoachLeaderAP(this.leaderUuid);
        } else {
          response = await api.getActionPlanStat();
        }
        // console.log(response);
        this.localOverview = response.data;
      } catch (err) {
        console.log(err);
        // if (err.msg) {
        //   this.$message.error(err.msg);
        // }
        this.localOverview = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#overviewMain {
  .mHead {
    color: var(--themeFontColor);
    padding: 0 10px;
  }

  .top,
  .details {
    margin-top: 15px;
  }
}
</style>
